import Mountain from '../assets/images/Mountain.png';
import Swamp from '../assets/images/Swamp.png';
import Forest from '../assets/images/Forest.png';
import Island from '../assets/images/Island.png';
import Plains from '../assets/images/Plains.png';
import Colorless from '../assets/images/Colorless.png';

export const inputs = [
  {
    id: 1,
    value: 'white',
    title: 'White',
    imgSrc: Plains,
  },
  {
    id: 2,
    value: 'red',
    title: 'Red',
    imgSrc: Mountain,
  },
  {
    id: 3,
    value: 'green',
    title: 'Green',
    imgSrc: Forest,
  },
  {
    id: 4,
    value: 'blue',
    title: 'Blue',
    imgSrc: Island,
  },
  {
    id: 5,
    value: 'black',
    title: 'Black',
    imgSrc: Swamp,
  },
  {
    id: 6,
    value: 'colorless',
    title: 'Colorless',
    imgSrc: Colorless,
  },
];
